module.exports = __webpack_public_path__ + "4737e655c06d783bf9e4f6087a58f9aa.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_3.png
// module id = 71
// module chunks = 0